<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="Tipo Relatório">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <!-- <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="_id" placeholder="_ID" v-model="form._id" disabled />
                  <label for="_id">_ID</label>
                </div>
              </b-col> -->
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="namePtBr" placeholder="Nome PT-BR" v-model="form.namePtBr" />
                  <label for="name">Nome PT-BR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEnEu" placeholder="Nome EN-EU" v-model="form.nameEnEu" />
                  <label for="name">Nome EN-EU</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEsEs" placeholder="Nome ES-ES" v-model="form.nameEsEs" />
                  <label for="name">Nome ES-ES</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEsAr" placeholder="Nome ES-AR" v-model="form.nameEsAr" />
                  <label for="name">Nome ES-AR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="namePtPt" placeholder="Nome PT-PT" v-model="form.namePtPt" />
                  <label for="namePtPt">Nome PT-PT</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameZhCn" placeholder="Nome ZH-CN" v-model="form.nameZhCn" />
                  <label for="nameZhCn">Nome ZH-CN</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="hatPtBr" placeholder="Chapéu PtBr" v-model="form.hatPtBr" />
                  <label for="hatPtBr">Chapéu PtBr</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="hatEnEu" placeholder="Chapéu EnEu" v-model="form.hatEnEu" />
                  <label for="hatEnEu">Chapéu EnEu</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="hatEsEs" placeholder="Chapéu EsEs" v-model="form.hatEsEs" />
                  <label for="hatEsEs">Chapéu EsEs</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="hatEsAr" placeholder="Chapéu EsAr" v-model="form.hatEsAr" />
                  <label for="hatEsAr">Chapéu EsAr</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="hatPtPt" placeholder="Chapéu PtPt" v-model="form.hatPtPt" />
                  <label for="hatPtPt">Chapéu PtPt</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="hatZhCn" placeholder="Chapéu ZhCn" v-model="form.hatZhCn" />
                  <label for="hatZhCn">Chapéu ZhCn</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              
              <b-col class="mb-2" md="12"><hr /></b-col>

              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Origem</label>
                  <b-form-group label="Origem" label-for="origin-list">
                    <v-select
                      id="origin-list"
                      v-model="form.origin"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="origins"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="subject-list">Assunto</label>
                  <b-form-group label="Assunto" label-for="subject-list">
                    <v-select
                      id="subject-list"
                      v-model="form.subject"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="subjects"
                      multiple
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="subject-list">Termos de busca</label>
                  <b-form-group label="Termos de busca" label-for="report-type-search">
                    <v-select
                      id="report-type-search"
                      v-model="form.reportType_search"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="reportType_search"
                      taggable
                      class="tags-class"
                      pill
                      push-tags
                      :closeOnSelect="false"
                      :tabindex="5"
                      multiple
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Pacote</label>
                  <b-form-group label="Pacote" label-for="package-list">
                    <v-select
                      id="package-list"
                      v-model="form.package"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="packages"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="content-list">Conteudo</label>
                  <b-form-group label="Conteudo" label-for="content-list">
                    <v-select
                      id="content-list"
                      v-model="form.content"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="content"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Caracteristica</label>
                  <b-form-group label="Caracteristica" label-for="characteristic-list">
                    <v-select
                      id="characteristic-list"
                      v-model="form.characteristic"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="characteristic"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Periodicidade</label>
                  <b-form-group label="Periodicidade" label-for="periodicity-list">
                    <v-select
                      id="periodicity-list"
                      v-model="form.periodicity"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="periodicity"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="groups-list">Grupos</label>
                  <b-form-group label="Grupos" label-for="groups-list">
                    <v-select
                      id="group-list"
                      v-model="form.reportTypeGroups"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="reportTypeGroups"
                      multiple
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="filter" placeholder="Filtro" v-model="form.filter" disabled/>
                  <label for="name">Filtro</label>
                </div>
              </b-col>
              
              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="active" name="active" checked="true" v-model="form.active">
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
                  Enviar
                </b-button>
                <b-button
                  variant="danger"
                  class="mr-1"
                  @click="onBackPage"
                >
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
} from "bootstrap-vue";
import reportTypeService from "@/providers/reportTypeService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import vSelect from "vue-select";
import AppConstants from '@/appConstants';

export default {
  props: {},
  data() {
    return {
      dataID: null,
      origins: [],
      subjects: [],
      content: [],
      packages: [],
      characteristic: [],
      periodicity: [],
      reportTypeGroups: [],
      form: {
        _id: "",
        namePtBr: "",
        nameEnEu: "",
        nameEsEs: "",
        nameEsAr: "",
        namePtPt: "",
        nameZhCn: "",
        hatPtBr: "",
        hatEnEu: "",
        hatEsEs: "",
        hatEsAr: "",
        hatPtPt: "",
        hatZhCn: "",
        hat: "",
        filter: "",
        origin: "",
        package: "",
        subject: [],
        reportTypeGroups: [],
        reportType_search: [],
        content: "",
        characteristic: "",
        periodicity: "",
        active: true,
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Novo Tipo Relatório');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
    }

    this.loadOrigin();
    this.loadReportTypeGroups();
  },
  watch: {
    "form.name"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Novo Tipo Relatório');
      }
    },
    "form.origin"(val) {
      if (val) {
        this.loadDataByOrigin();
      }
    },
    "form.subject"(val) {
      if (val) {
        if (val.length > 0) {
          this.loadContentBySubject();
        }
      }
    }
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_REPORT_TYPE);
    },
    onSubmit() {
      // const form = JSON.parse(JSON.stringify(this.form));
      reportTypeService
        .registerReportType(this.form, new URLSearchParams())
        .then(() => {
          // console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getReportTypeDetails() {
      const params = new URLSearchParams();
      reportTypeService
        .getReportTypeDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.namePtBr = res.namePtBr;
          this.form.nameEnEu = res.nameEnEu;
          this.form.nameEsEs = res.nameEsEs;
          this.form.nameEsAr = res.nameEsAr;
          this.form.namePtPt = res.namePtPt;
          this.form.nameZhCn = res.nameZhCn;
          this.form.hatPtBr = res.hatPtBr;
          this.form.hatEnEu = res.hatEnEu;
          this.form.hatEsEs = res.hatEsEs;
          this.form.hatEsAr = res.hatEsAr;
          this.form.hatPtPt = res.hatPtPt;
          this.form.hatZhCn = res.hatZhCn;
          this.form.filter = res.filter;
          this.form.origin = res.origin;
          this.form.content = res.content;
          this.form.subject = res.subject;
          this.form.reportType_search = res.reportType_search;
          this.form.reportTypeGroups = res.reportTypeGroups;
          // this.form.hat = res.hat;
          this.form.package = res.package;
          this.form.characteristic = res.characteristic;
          this.form.periodicity = res.periodicity;
          this.form.active = res.active;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadOrigin() {
      dropdownService.getAllOrigin(new URLSearchParams())
      .then(res => {
        this.origins = res;
        if (this.isUpdate) {
            this.getReportTypeDetails();
          }
      })
      .catch((err) => console.log(err));
    },
    loadContentBySubject() {
      this.content = [];
      if (!this.isUpdate) {
        this.form.content = null;
      }
      const params = new URLSearchParams();
      params.append('origins', this.form.origin.id)
      params.append('subjects', this.form.subject.map(item => item.id).join(','));
      params.append('isQuotes', false);
      params.append('layout', AppConstants.NEWS_LAYOUT.REPORT);
      dropdownService.getContentBySubject(params)
      .then(res => {
        this.content = res;
      })
      .catch((err) => console.log(err));
    },
    loadDataByOrigin() {
      if (!this.isUpdate) {
        this.subjects = [];
        this.form.subject = [];
        this.packages = [];
        this.form.package = null;
        this.characteristic = [];
        this.form.characteristic = null;
        this.periodicity = [];
        this.form.periodicity = null;
      }
      const params = new URLSearchParams();
      params.append('origins', this.form.origin.id)
      Promise.all([
        dropdownService.getPackage(params),
        dropdownService.getCharacteristic(params),
        dropdownService.getPeriodicity(params),
        dropdownService.getAllSubjects(params),
      ]).then((res) => {
          this.packages = res[0];
          this.characteristic = res[1];
          this.periodicity = res[2];
          this.subjects = res[3];
        })
        .catch((err) => console.log(err));
    },
    loadReportTypeGroups() {
      dropdownService.getAllReportTypeGroups(new URLSearchParams())
      .then(res => {
        this.reportTypeGroups = res;
        if (this.isUpdate) {
            this.getReportTypeDetails();
          }
      })
      .catch((err) => console.log(err));
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    vSelect
  },
};
</script>

<style lang="scss">
.subject-badge-select {
  margin-bottom: 10px;
  .badge {
    margin: 0px 5px;
  }
}
</style>